/**
 * 使用变量
 * @return {object}  FEGO变量
 */
export function useVariable() {
    return window.FEGORender.store.variable.data;
}
